
import { Relation, GetUploadRelationsDocument } from 'coghent-vue-3-component-library'
import { BaseIcon, Metadata, KeyValuePair } from 'coghent-vue-3-component-library'
import { defineComponent, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { debounce } from 'ts-debounce'
import { uploadState } from 'coghent-vue-3-component-library'
import { useQuery } from '@vue/apollo-composable'
import { Entity } from 'coghent-vue-3-component-library'
import { getMetadataOfTypeFromEntity } from 'coghent-vue-3-component-library'
import uploadWizard, { MetadataQuestion } from '@/composables/uploadWizard'

export default defineComponent({
  components: {
    BaseIcon,
  },
  emits: [`updatedMetadata`, 'updatedRelations', 'stepDone'],
  setup(props, { emit }) {
    const { t } = useI18n()
    const { getMetadataWithQuestions } = uploadWizard()
    const metadata = ref<Array<MetadataQuestion>>([])
    const relations = ref<Array<typeof Relation>>([])
    const relationSearch = ref<string>('')
    const dropdownResults = ref<Array<typeof KeyValuePair>>([])

    const { fetchMore } = useQuery(GetUploadRelationsDocument, { searchValue: '' })

    const setRelationDropdownData = (_entities: Array<typeof Entity>) => {
      const data: Array<typeof KeyValuePair> = []
      for (const entity of _entities) {
        let value = null
        if (entity.type === 'person') {
          const found = getMetadataOfTypeFromEntity(entity, 'fullname')
          found ? (value = found.value) : null
        }
        if (entity.type === 'getty') {
          const found = getMetadataOfTypeFromEntity(entity, 'title')
          found ? (value = found.value) : null
        }
        if (value != null) {
          data.push({
            key: entity.id,
            value: value,
          } as typeof KeyValuePair)
        }
      }
      dropdownResults.value = data
    }

    watch(relationSearch, async (value) => {
      relationSearch.value = await debounce(() => relationSearch.value, 100)()
      dropdownResults.value = []
      if (relationSearch.value !== '' || relationSearch.value !== null) {
        const response = await fetchMore({ variables: { searchValue: relationSearch.value } })
        response?.data.GetUploadRelations ? setRelationDropdownData(response.data.GetUploadRelations.results) : null
      }
    })

    const addToRelations = (_keyValue: typeof KeyValuePair) => {
      const found = relations.value.find((keypair) => keypair.key === _keyValue.key)
      if (found === undefined) {
        relations.value.push({
          key: _keyValue.key,
          value: _keyValue.value,
        } as typeof Relation)
        updateRelations()
      }
    }

    const removeFromRelations = (_relation: typeof KeyValuePair) => {
      relations.value = relations.value.filter((relation: typeof Relation) => relation != _relation)
      updateRelations()
    }

    const updateMetadata = () => {
      const updatedMetadata: Array<typeof Metadata> = []
      for (const meta of metadata.value) {
        if (meta.answer != null && meta.answer != '') {
          updatedMetadata.push({
            key: meta.key,
            value: meta.answer,
            label: meta.text,
          } as typeof Metadata)
        }
      }
      emit(`updatedMetadata`, updatedMetadata)
    }

    const setRelations = () => {
      if (uploadState.relations && uploadState.relations.length >= 1) {
        for (const relation of uploadState.relations) {
          relations.value.push({ key: relation.key, value: relation.value } as typeof KeyValuePair)
        }
      } else if (uploadState.relation === undefined) {
        uploadState.relations = []
      }
    }

    const updateRelations = () => {
      emit(`updatedRelations`, relations.value)
      dropdownResults.value = []
      relationSearch.value = ''
    }

    const checkFields = () => {
      emit(`stepDone`, false)
    }

    const init = () => {
      console.log(`uploadState.metadata`, uploadState.metadata)
      metadata.value = getMetadataWithQuestions()
      setRelations()
      checkFields()
    }

    init()

    return {
      t,
      metadata,
      relations,
      relationSearch,
      dropdownResults,
      addToRelations,
      removeFromRelations,
      updateMetadata,
      updateRelations,
    }
  },
})
